import StatsSection from './StatsSection.vue'

export default StatsSection
